<template>
  <div class="l-edit-dialog-box">
    <el-form :model="form_data" label-width="120px" ref="form" :rules="rules" label-position="left" v-loading="loading">
      <el-row :gutter="50" style="margin-left:0;margin-right:0">

        <!-- <el-col :span="24">
          <el-form-item label="选择场所类型" prop="type">
            <el-select v-model="form_data.type" placeholder="全部" clearable>
              <el-option v-for="(item, index) in PLACE_STATE" :key="index" :label="item" :value="index"> </el-option>
            </el-select>
          </el-form-item>
        </el-col> -->
        <el-col :span="24">
          <el-form-item label="状态" prop="state">
            <el-radio-group v-model="form_data.state">
              <el-radio :label="parseInt(index)" v-for="(item,index) in STATE_NAMES" :key="index">{{item}}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="添加等级" prop="grade">
            <el-radio-group v-model="form_data.grade">
              <el-radio :label="parseInt(index)" v-for="(item,index) in STATE" :key="index" @change="changes">{{item}} </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="上级" prop="pid">
            <el-cascader v-model="form_data.pid" :options="tree_node" :props="{ checkStrictly: true }" :disabled="tree_node.length==0" clearable></el-cascader>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="计数" prop="fraction">
            <el-input-number v-model="form_data.fraction" :min="0" :max="100" label="对应的分数(分)"></el-input-number>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item label="项目" prop="name" v-if="form_data.grade == 1">
            <el-input type="textarea" v-model="form_data.name" autocomplete="off" :rows="6" maxlength="250" placeholder="请输入检查项目"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="内容" prop="name" v-if="form_data.grade == 2">
            <el-input type="textarea" v-model="form_data.name" autocomplete="off" :rows="6" maxlength="250" placeholder="请输入检查内容"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="标准" prop="name" v-if="form_data.grade == 3">
            <el-input type="textarea" v-model="form_data.name" autocomplete="off" :rows="6" maxlength="250" placeholder="请输入检查标准"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="检查方法" prop="inspection_method" v-if="form_data.grade == 3">
            <el-input v-model="form_data.inspection_method" autocomplete="off" placeholder="请输入检查方法"></el-input>
          </el-form-item>
        </el-col>
        <!-- <el-col :span="24">
          <el-form-item label="标准检查等级" prop="danger_lavel" v-if="form_data.grade == 3">
            <el-radio-group v-model="form_data.danger_lavel">
              <el-radio :label="parseInt(index)" v-for="(item,index) in LEVEL" :key="index">{{item}}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col> -->
      </el-row>

    </el-form>
    <div class="l-dialog-footer">
      <el-button @click="cancel">取 消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="submitting">确 定</el-button>
    </div>
  </div>

</template>

<script>
import { STATE, PLACE_STATE, STATE_NAMES, LEVEL } from './rental';
export default {
  name: 'l-rental-edit',
  props: {
    id: {
      type: [String, Number],
      default: null
    },
    visible: {
      type: Boolean,
    },
    useType: {
      type: [Number],
      default: 1
    }
  },

  components: {
  },
  computed: {
    hasId() {
      return this.$props.id !== null;
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler(val) {
        if (val) {
          this.getData();
        }
      }
    }
  },
  data() {
    return {
      loading: false,//页面是否加载中

      //资源类型
      STATE: STATE,
      PLACE_STATE: PLACE_STATE,
      STATE_NAMES: STATE_NAMES,
      LEVEL: LEVEL,
      //是否显示
      tree_node: [

      ],
      //表单数据
      form_data: {
        //场所类型工业企业
        place_type: 5,
        name: '',
        type: '1',
        state: 1,
        grade: 1,
        pid: [],
        fraction: 0,
        inspection_method: '',
        danger_lavel: ''
      },
      //表单验证规则
      rules: {
        name: [
          { required: true, message: '内容不能为空', trigger: 'change' }
        ],
        grade: [
          { required: true, message: '上级不能为空', trigger: 'change' }
        ],
        state: [
          { required: true, message: '状态不能为空', trigger: 'change' }
        ],
        fraction: [
          { required: true, message: '分数不能为空', trigger: 'change' }
        ],
      },
      //提交按钮是否显示加载中
      submitting: false,
    }
  },

  methods: {
    //点击取消通知父组件关闭对话框
    cancel() {
      this.$emit('update:visible', false);
    },
    changes() {
      this.$_invoke("checkSpecs_rentalGetSuperior", {
        grade: this.form_data.grade,
        place_type: this.form_data.place_type
        // pid_ids: this.form_data.street_ids
      }).then((ret) => {
        this.tree_node = ret
      })
        .finally(() => {
          this.loading = false;
        });
    },
    //获取数据
    getData() {
      if (this.hasId) {
        this.loading = true;
        this.$_invoke(`checkSpecs_getEditData`, { id: this.$props.id }).then((ret) => {
          this.form_data = ret.data;
          this.tree_node = ret.superior;
        }).finally(() => {
          this.loading = false;
        });

      } else {
        this.form_data.use_type = this.$props.useType
      }
    },

    //提交数据
    handleSubmit() {
      if (this.loading) return;
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submitting = true;
          if (!this.hasId) {//添加
            this.$_invoke('checkSpecs_rentalSave',
              this.form_data).then(() => {
                this.$_msg.success('添加成功');
                this.$emit('on-success');
              }).finally(() => {
                this.submitting = false;
              })
          } else {//修改
            this.$_invoke(`checkSpecs_update`, {
              id: this.$props.id,
              ...this.form_data
            }).then(() => {
              this.$_msg.success('修改成功');
              this.$emit('on-success');
            }).finally(() => {
              this.submitting = false;
            })
          }
        }
      })

    },
  },
}
</script>